import React, { useEffect, useRef } from 'react';

import './animation1';


const Spanizer = React.memo(({ text }) => {
  const spanParentRef = useRef(null);

  useEffect(() => {

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('no-animation');
          } else {
            entry.target.classList.add('no-animation'); 
          }
        });
      },
      {
        root: null, // relative to the viewport
        rootMargin: '0px',
        threshold: 0.1 // adjust this value based on your needs
      }
    );

    if (spanParentRef.current) {
      observer.observe(spanParentRef.current);
    }

    return () => {
      if (spanParentRef.current) {
        observer.unobserve(spanParentRef.current);
      }
    };
  }, []);

  return (
    <p className="mast__text" >
    <span ref={spanParentRef}>
      {text.split("").map((char, index) => (
        <span key={index}>{char}</span>
      ))}
    </span>
    </p>
  );
});

export default Spanizer;
